import { Box, Button } from "@mui/material";
import SimpleBody from "../../../../components/forms/SimpleBody";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faSearch, faTrash } from "@fortawesome/free-solid-svg-icons";
import { normalizeFormErrors } from "../../../../utils/objectUtils";
import { ReturnConfirmationModal } from "./ReturnConfirmationModal";

/**
 *
 * @param {{ fields: any; formData: any; handleChange: any; formErrors: any; actions: {
 *    search: void;
 *    clearList: void
 *    confirmAll: void
 *    releaseToStock: void
 * }; }} param0
 * @returns
 */
export default function FormScanner({
  fields,
  formData,
  handleChange,
  formErrors,
  actions,
  data,
  modal = {
    open: false,
    onClose: () => {},
    onClear: () => {},
  },
}) {
  return (
    <>
      <Box
        sx={{
          display: "column",
          justifyContent: "space-between",
        }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "10px",
          }}>
          <SimpleBody
            fields={fields}
            formErrors={normalizeFormErrors(formErrors)}
            formData={formData}
            handleFieldChange={handleChange}
            getOptions={() => {}}
            getSelectedValue={() => {}}
            getSelectMeta={() => {}}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            marginTop: "10px",
            gap: "14px",
            alignItems: "flex-start",
          }}>
          <Button
            sx={{
              backgroundColor: "#fff",
              color: "#000",
              textTransform: "capitalize",
              fontWeight: "600",
              boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.25)",
              ":hover": {
                backgroundColor: "#f0f0f0",
                color: "#000",
              },
            }}
            onClick={actions.search}>
            <FontAwesomeIcon icon={faSearch} className="mr-2" />
            Localizar
          </Button>
          <Button
            sx={{
              backgroundColor: "#DC3545",
              color: "#fff",
              textTransform: "capitalize",
              fontWeight: "600",
              boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.25)",
              ":hover": {
                backgroundColor: "#E62135",
                color: "#fff",
              },
            }}
            onClick={actions.clearList}>
            <FontAwesomeIcon icon={faTrash} className="mr-2" />
            Limpar Lista
          </Button>
          <Button
            sx={{
              backgroundColor: "#FFA500",
              color: "#000",
              textTransform: "capitalize",
              fontWeight: "600",
              boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.25)",
              ":hover": {
                backgroundColor: "#F7A815",
                color: "#000",
              },
            }}
            onClick={actions.confirmAll}>
            <FontAwesomeIcon icon={faCheck} className="mr-2" />
            Confirmar Equipamentos Escaneados ({data?.length || 0})
          </Button>
        </Box>
      </Box>
      <ReturnConfirmationModal
        data={data}
        open={modal.open}
        onClose={modal.onClose}
        onClear={modal.onClear}
        hasMixedStatuses={modal.hasMixedStatuses}
      />
    </>
  );
}
